import React from 'react';
import { GenericFilterHeader } from './GenericFilterHeader';

const SURVEY_OPTIONS = ['All', 'From survey', 'Not from survey'];

interface SurveyColumnHeaderProps {
    readonly currentValue: string[] | null;
    readonly onChange: (value: string[] | null) => void;
}

export function SurveyHeader({
    currentValue,
    onChange,
}: SurveyColumnHeaderProps) {
    return (
        <GenericFilterHeader
            label="Survey"
            filterOptions={SURVEY_OPTIONS}
            currentValue={currentValue}
            onChange={onChange}
        />
    );
}

SurveyHeader.displayName = 'SurveyHeader';
